import { Link } from 'react-router-dom';
import { articleData } from '@/mocks/articles';

export default function SEOSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-12 gap-3">
          <div>
            <span className="text-xs md:text-sm text-foreground-400 font-medium tracking-wide uppercase">
              Artigos SEO
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mt-2">
              Guias &amp;{' '}
              <span className="text-accent-500">Artigos</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-1 max-w-lg">
              Conteúdo original em português para ajudar você a dominar as compras internacionais com HoobuySpreadsheet.
            </p>
          </div>
          <Link
            to="/artigo/guia-completo-hoobuyspreadsheet-2026"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            Ver todos os artigos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleData.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group block bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer hover:-translate-y-1 transition-all"
            >
              <div className="h-44 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-foreground-400 uppercase tracking-wide">
                  {article.category}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mt-1.5 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}